<template>
  <HeadlineComponent
    >Neue Aufgabe in Team "{{ team.name }}" anlegen</HeadlineComponent
  >
  <Form
    class="form-horizontal"
    @submit="create"
    :initialValues="initialValues"
    v-slot="{ values }"
    v-if="loaded"
  >
    <TaskForm :values="values" :startDate="team.start_date"></TaskForm>
    <LoadingButton class="btn-primary" :loading="loading"
      >Anlegen</LoadingButton
    >
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import teamService from "@/services/team.service.js";
import taskService from "@/services/task.service.js";
import moment from "moment";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import { Form } from "vee-validate";
import TaskForm from "@/components/TaskForm.vue";
import { setErrors } from "@/helper/ErrorToActions.js";
import * as Sentry from '@sentry/vue';

export default {
  name: "CreateTaskView",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { LoadingButton, HeadlineComponent, Form, TaskForm },
  data() {
    return {
      team: {},
      loading: false,
      initialValues: { ticket_relevant: true, shifts: [] },
      loaded: false,
    };
  },
  async beforeMount() {
    if (this.$route.params.task) {
      try {
        let response = await taskService.get(
          this.$route.params.event,
          this.$route.params.team,
          this.$route.params.task
        );
        this.initialValues.name = response.data.name;
        this.initialValues.ticket_relevant = response.data.ticket_relevant;
        for (let shift of response.data.shifts) {
          this.initialValues.shifts.push({
            start: moment(shift.start).format("YYYY-MM-DDTHH:mm"),
            end: moment(shift.end).format("YYYY-MM-DDTHH:mm"),
          });
        }
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    }
    try {
      let response = await teamService.get(
        this.$route.params.event,
        this.$route.params.team
      );
      this.team = response.data;
      this.team.start_date = moment(this.team.start_date).format(
        "YYYY-MM-DDTHH:mm"
      );
    } catch (e) {
      if (!e) return;
      Sentry.captureException(e);
      this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
      window.scrollTo(0, 0);
    }
    this.loaded = true;
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async create(data, actions) {
      this.loading = true;
      var shifts = [];
      for (let shift of data.shifts) {
        var start = moment(shift.start, "YYYY-MM-DDTHH:mm");
        var end = moment(shift.end, "YYYY-MM-DDTHH:mm");

        // sollte nicht passieren, aber mal sicher gehen..
        if (!start.isValid() || !end.isValid()) {
          this.addAlert(
            "danger",
            "Alle Schichten brauchen gültige Start und Endzeiten."
          );
          this.loading = false;
          return;
        }
        var s = {
          start: start.format(),
          end: end.format(),
          ticket_relevant: data.ticket_relevant,
        };
        shifts.push(s);
      }
      try {
        let form = {
          name: data.name,
          ticket_relevant: data.ticket_relevant,
          locked: data.locked,
          shifts: shifts,
        };
        await taskService.create(this.$route.params.event, this.team.id, form);
        this.addAlert("success", "Aufgabe erfolgreich hinzugefügt");
        this.$router.push({
          path: "/teams",
          query: { event_id: this.$route.params.event },
        });
      } catch (e) {
        if (e) {
          if (e.response && e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions);
            this.loading = false;
            return;
          } else {
            console.log(e);
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
